export const Constants = {
  mdXsMax: "(max-width: 639px)",
  mdSm: "(min-width:640px)",
  mdMd: "(min-width:768px)",
  mdLg: "(min-width:1024px)",
  mdXl: "(min-width:1280px)",
  md2Xl: "(min-width:1536px)",
  md3Xl: "(min-width:1600px)",
  label: "block text-sm font-medium leading-6 text-gray-900",
  labelOn: "pointer-events-none absolute top-0 left-2 px-2 origin-left -translate-y-1/2 transform text-gray-800 transition-all duration-100 ease-in-out peer-placeholder-shown:top-[1.8em] peer-placeholder-shown:peer-disabled:opacity-50 bg-stone-50 peer-placeholder-shown:text-lg peer-placeholder-shown:text-gray-500 peer-placeholder-shown:bg-white peer-focus:top-0 peer-focus:text-sm peer-focus:text-gray-800",
  inputDef: "block px py-sm w-full text-gray-900 bg-gray-50 rounded border border-gray-300 appearance-none focus:outline-none focus:ring-0 focus:border-primary/50 invalid:[&:not(:placeholder-shown):not(:focus)]:border-red-500 peer",
  textError: "invisible text-red-500 peer-placeholder-shown:invisible peer-placeholder-shown:[&:peer-invalid]:visible text-xs mt-1 font-bold",
  active: "border-s-2 border-secondary ps-2 font-bold",
  btnWhite: "block bg-white border border-primary hover:bg-primary hover:text-white",
  btnGray: "block bg-stone-100 border border-primary hover:bg-primary hover:text-white",
  btnWhiteRed: "block text-red-900 bg-white border border-red-600 hover:text-white hover:bg-red-500",
  btnWhiteGreen: "block bg-white border border-primary hover:text-white hover:bg-success",
  btnBlack: "block bg-primary text-white border border-primary hover:bg-white hover:text-primary focus:z-10 focus:ring-4 focus:ring-gray-200 focus:outline-none",
} as const;
export type Constants = (typeof Constants)[keyof typeof Constants];
